import { render, staticRenderFns } from "./MerchantLocationTransactions.vue?vue&type=template&id=ec9a04a6&"
import script from "./MerchantLocationTransactions.vue?vue&type=script&lang=js&"
export * from "./MerchantLocationTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports